module.exports = __webpack_public_path__ + "img/flaggstikk_double_2.705c52b3.jpg";